import { render, staticRenderFns } from "./CardBySide4.vue?vue&type=template&id=230170b4&scoped=true&"
import script from "./CardBySide4.vue?vue&type=script&lang=js&"
export * from "./CardBySide4.vue?vue&type=script&lang=js&"
import style0 from "./CardBySide4.vue?vue&type=style&index=0&id=230170b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230170b4",
  null
  
)

export default component.exports